
<div mat-dialog-title>Import Orders</div>
<mat-dialog-content>
  <button class="close" mat-button mat-dialog-close (click)="cancel()"><i class="material-icons clear" >clear</i></button>
  @if (hasFile && !isValidFile) {
    <mat-card class="error block">
      <mat-card-title class="error">{{invalidFileErrorHeader}}</mat-card-title>
      <mat-card-subtitle style="font-family: Arial;font-size: 13px;color: #000000;" >{{invalidFileErrorMessage}}</mat-card-subtitle>
    </mat-card>
  }
  @if (errorMessage) {
    <mat-card class="error block">
      <mat-card-title class="error">An error occurred.</mat-card-title>
      <mat-card-subtitle style="font-family: Arial;font-size: 13px;color: #000000;">{{errorMessage}}</mat-card-subtitle>
    </mat-card>
  }
  <div>You can use this import to add orders to the iRebal order blotter.<br>
    Note: Tax Lot ID (depletion) method, Short Sell, Buy to Cover, Do Not Reduce, and All or None order instructions are not currently supported in iRebal. All imported sell orders will use the default depletion method on the account.
  </div>
  <div>
    <table class="import" width="100%">
      <tr>
        <th align="left" style="vertical-align: top;"><label>File name</label></th>
        <td>
          <div class="bottomPaddingElementDialog">
            <irb-file-selector (change)="fileUploaded($event)"></irb-file-selector>
            <div>File type must be .csv</div>
          </div>
        </td>
      </tr>
      <tr>
        <th align="left" style="vertical-align: top;"><label>Instructions</label></th>
        <td><div class="block">Your selected file must be in .csv format and follow iRebal's order entry requirements.</div></td>
      </tr>
      <tr>
        <th align="left" style="vertical-align: top;"><label>Template</label></th>
        <td>
          <div>Use our Import Order PDF to help prepare your file.<br/>
            <a href='/assets/template/Import_Orders.pdf'>Download template: Import_Orders.pdf</a></div>
          </td>
        </tr>
      </table>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button class="btn-medium-secondary" (click)="cancel()">Cancel</button>
    <button id="continueButton" class="btn-medium-primary" cdkFocusInitial [disabled]="disableContinue" (click)="validateImportOrders()">Continue</button>
  </mat-dialog-actions>

